export default __webpack_public_path__ + "static/error-1ec17b62e4a2a4483d8d87ed58abf724.png";